import { walletOffersApi } from "@b2bportal/core-wallet-offer";
import type { EligibleProduct } from "@b2bportal/wallet-offer-api";

import { filterOffersForProduct } from "./filterOffersForProduct";

export interface UseWalletOffersOptions {
  /** Skip the network request (e.g. when the user is logged out). */
  skip?: boolean;
}

export const useWalletOffers = ({ skip }: UseWalletOffersOptions = {}) => {
  const { data, isLoading, isError } =
    walletOffersApi.useFetchAllWalletOffersQuery(undefined, { skip });

  const offers = data?.offers ?? [];

  return {
    offers,
    getOffersForProduct: (product: EligibleProduct) =>
      filterOffersForProduct(offers, product),
    isLoading,
    isError,
  };
};
